module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    on: {
      "click": _vm.previousFFView
    }
  }, [_vm._v("« Back")])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('h2', [_vm._v("Documentation NOC")])])], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "vehicleBooking"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle md-active",
    attrs: {
      "id": "showVisibility"
    },
    on: {
      "click": _vm.showOverflow
    }
  }, [_c('span', [_vm._v("Documentation - Noc")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "70"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Current Date & Time")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.NocModel.currentDate),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "currentDate", $$v)
      },
      expression: "NocModel.currentDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Importer Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "importerName",
      "name": "importerName"
    },
    model: {
      value: (_vm.NocModel.importerName),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "importerName", $$v)
      },
      expression: "NocModel.importerName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('label', [_vm._v("House B/L Receiving Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "lang": "en",
      "name": "weighingDate",
      "id": "weighingDate",
      "type": "datetime",
      "format": "YYYY-MM-DD hh:mm a"
    },
    model: {
      value: (_vm.NocModel.receivingDate),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "receivingDate", $$v)
      },
      expression: "NocModel.receivingDate"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Enter MBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "mblNo",
      "name": "mblNo"
    },
    model: {
      value: (_vm.NocModel.mblNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "mblNo", $$v)
      },
      expression: "NocModel.mblNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Enter HBL No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "hblNo",
      "name": "hblNo"
    },
    model: {
      value: (_vm.NocModel.hblNo),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "hblNo", $$v)
      },
      expression: "NocModel.hblNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  })], 1), _vm._v(" "), (_vm.NormalseaImportDataModel.containerInfo == 'lcl') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Co-Loader Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "coLoaderName",
      "name": "coLoaderName"
    },
    model: {
      value: (_vm.NocModel.coLoaderName),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "coLoaderName", $$v)
      },
      expression: "NocModel.coLoaderName"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.NormalseaImportDataModel.containerInfo == 'lcl') ? _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('label', [_vm._v("Co-Loader Address")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "coloaderAdd",
      "name": "coloaderAdd"
    },
    model: {
      value: (_vm.NocModel.coloaderAdd),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "coloaderAdd", $$v)
      },
      expression: "NocModel.coloaderAdd"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('u', [_vm._v("Container Detail")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "FreghtContaner"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Container No")]), _vm._v(" "), _c('th', [_vm._v("Seal No")]), _vm._v(" "), _c('th', [_vm._v("Package Detail")]), _vm._v(" "), _c('th', [_vm._v("Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Measurement(CBM)")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.getContainerList), function(item1, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v("\n                            " + _vm._s(item1.containerNo) + "\n                            "), _c('br'), _vm._v("\n                            " + _vm._s(item1.containerType) + "\n                          ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.lineSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.noOfPkg) + " " + _vm._s(item1.packageName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.grossWeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item1.measurement))])])
  }))])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  })]), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Preparation of NOC for Shipping Line")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    staticStyle: {
      "width": "100% !important",
      "height": "500px !important"
    },
    model: {
      value: (_vm.NocModel.nocPreparation),
      callback: function($$v) {
        _vm.$set(_vm.NocModel, "nocPreparation", $$v)
      },
      expression: "NocModel.nocPreparation"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderNoc"
    },
    on: {
      "click": _vm.addNocDocumentation
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loaderNoc"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }), _vm._v(" "), (_vm.NocModel.ffNocId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color md-theme-default back heght-1px",
    attrs: {
      "id": "addButtonLoaderAuth"
    },
    on: {
      "click": function($event) {
        _vm.Print('NocDoc', _vm.NocModel.uploadNocDoc)
      }
    }
  }, [_vm._v("Print")])], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose22
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose6
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPopData",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.ProceedSail
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8ee6f892","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/seaImport/ImportNOCDocNormal.vue
// module id = 2798
// module chunks = 0